/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OperatorTextsControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        operatorId,
        uiMode,
    }: {
        operatorId: number,
        uiMode: 'LIMITED' | 'FORBIDDEN',
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/program/operators/{operatorId}/texts/{uiMode}',
            path: {
                'operatorId': operatorId,
                'uiMode': uiMode,
            },
        });
    }
}
